export enum ACCOUNT_ROUTES {
  Base = 'AccountBase',
}

export enum APP_ROUTES {
  Account = 'AppAccount',
  Catalog = 'AppCatalog',
  Chat = 'AppChat',
  Chats = 'AppChats',
  Links = 'AppLinks',
  MenuInfo = 'AppMenuInfo',
  OrderGuide = 'AppOrderGuide',
  Orders = 'AppOrders',
  Payments = 'AppPayments',
  Restaurant = 'AppRestaurant',
  StorefrontMicroProduct = 'AppStorefrontMicroProduct',
}

export enum APP_CONTAINER_STACK_ROUTES {
  Container = 'Container',
}

export enum APP_CONTAINER_ROUTES {
  Account = 'AppContainerAccount',
  AccountNotificationSettings = 'AppContainerAccountNotificationSettings',
  Base = 'AppContainerBase',
  BrandPage = 'AppContainerBrandPage',
  CreditMemoDetail = 'AppContainerCreditMemoDetail',
  CreditRequestDetail = 'AppContainerCreditRequestDetail',
  CreditRequestInvoiceItems = 'AppContainerCreditRequestInvoiceItems',
  CustomTagPrint = 'AppContainerCustomTagPrint',
  DisplayAd = 'AppContainerDisplayAd',
  Employees = 'AppContainerEmployees',
  InsightsHub = 'AppContainerInsightsHub',
  InvoiceDetail = 'AppContainerInvoiceDetail',
  Links = 'AppContainerLinks',
  MenuDetail = 'AppContainerMenuDetail',
  MenuInfo = 'AppContainerMenuInfo',
  MenuItemDetail = 'AppContainerMenuItemDetail',
  NewOrder = 'AppContainerNewOrder',
  OrderCheckIn = 'AppContainerOrderCheckIn',
  OrderDetail = 'AppContainerOrderDetail',
  OriginalInbound = 'AppContainerOriginalInbound',
  PaymentDetail = 'AppContainerPaymentDetail',
  PaymentLinkDetail = 'AppContainerPaymentLinkDetail',
  Profile = 'AppContainerProfile',
  ShortPayCreditRequestItems = 'AppContainerShortPayCreditRequestItems',
  StorefrontMicroProduct = 'AppContainerStorefrontMicroProduct',
  TagPrintBatch = 'AppContainerTagPrintBatch',
}

export enum APP_MODAL_ROUTES {
  AccountNotificationSettings = 'AppModalAccountNotificationSettings',
  AddPAD = 'AppModalAddPAD',
  AddPaymentMethod = 'AppModalAddPaymentMethod',
  Base = 'AppModalBase',
  CheckCapture = 'AppModalCheckCapture',
  CollectPADConsent = 'AppModalCollectPADConsent',
  ContactSelector = 'AppModalContactSelector',
  CreateSubscription = 'AppModalCreateSubscription',
  CreditRequest = 'AppModalCreditRequest',
  DSRTooling = 'DSRTooling',
  EditNote = 'AppModalEditNote',
  EditOrderItemNoteModal = 'AppModalEditOrderItemNoteModal',
  EditSubscription = 'AppModalEditSubscription',
  HiddenAlerts = 'HiddenAlerts',
  InvoiceDetailModal = 'AppContainerInvoiceDetailModal',
  ItemDetails = 'AppModalItemDetails',
  LocationManager = 'AppModalLocationManager',
  PartialPayment = 'AppModalPartialPayment',
  QueuedOfflineOrders = 'AppModalQueuedOfflineOrders',
  RestaurantInviteEmployee = 'AppModalRestaurantInviteEmployee',
  TabCardApplication = 'AppModalTabCardApplication',
  UpdateEmployee = 'AppUpdateEmployee',
  ViewPADAgreement = 'AppModalViewPADAgreement',
}

export enum AUTH_ROUTES {
  GuestCatalog = 'GuestCatalog',
  SignIn = 'SignIn',
  SignInCode = 'SignInCode',
  Welcome = 'Welcome',
}

export enum AUTH_MODAL_ROUTES {
  Base = 'AuthModalBase',
  BecomeCustomer = 'AuthModalBecomeCustomer',
  LoginRecovery = 'AuthModalLoginRecovery',
}

// Outer modal stack wrapping the auth modal stack. Mirrors ContainerStack:
// the pickers live a level above the form modals so each is the top of its
// own navigator and renders as a centered card instead of stacking flat.
export enum AUTH_OUTER_MODAL_ROUTES {
  Base = 'AuthOuterModalBase',
}

export enum CONTAINER_MODAL_ROUTES {
  Base = 'ContainerModalBase',
  CountrySelector = 'ContainerModalCountrySelector',
  DemoSettings = 'ContainerModalDemoSettings',
  Licenses = 'ContainerModalLicenses',
  OrderInbounds = 'ContainerModalOrderInbounds',
  PlacesSearch = 'ContainerModalPlacesSearch',
}

export enum LOCATION_MANAGER_ROUTES {
  Base = 'LocationManagerBase',
  CreateAccount = 'LocationManagerCreateAccount',
  DuplicateOrder = 'LocationManagerDuplicateOrder',
  EditAccount = 'LocationManagerEditAccount',
  InviteEmployee = 'LocationManagerInviteEmployee',
  LeadGenerator = 'LocationManagerLeadGenerator',
  MenuCamera = 'LocationManagerMenuCamera',
  QueuedOfflineOrders = 'LocationManagerQueuedOfflineOrders',
  ViewAccount = 'LocationManagerViewAccount',
  ViewAccountEmployees = 'LocationManagerViewEmployees',
  ViewAccountMenu = 'LocationManagerViewMenu',
  ViewEmployeeDetail = 'LocationManagerViewEmployeeDetail',
  ViewEmployeeNotifications = 'LocationManagerViewEmployeeNotifications',
  ViewImageGeneratedMenu = 'LocationManagerViewImageGeneratedMenu',
}

export enum NEW_ORDER_ROUTES {
  OrderSummary = 'NewOrderSummary',
  PaymentMethod = 'NewOrderPaymentMethod',
  Substitutions = 'NewOrderSubstitutions',
}

export enum ORDER_ROUTES {
  Orders = 'Orders',
  Subscriptions = 'Subscriptions',
}

export enum CREDIT_REQUEST_ROUTES {
  Base = 'CreditRequestBase',
}

export enum CREDIT_REQUEST_INVOICE_ROUTES {
  CreditRequestInvoiceDetails = 'CreditRequestInvoiceDetails',
  CreditRequestInvoiceItems = 'CreditRequestInvoiceItems',
}

export enum SHORT_PAY_CREDIT_REQUEST_ROUTES {
  Details = 'ShortPayCreditRequestDetails',
  Items = 'ShortPayCreditRequestItems',
}

export enum CHECK_IN_ROUTES {
  Base = 'CheckInBase',
  CheckInReportAnIssue = 'CheckInReportAnIssue',
  CheckInSingleItem = 'CheckInSingleItem',
}

export enum CATALOG_ROUTES {
  Base = 'CatalogBase',
  BrandPage = 'CatalogBrandPage',
  CatalogUnifiedSearch = 'CatalogUnifiedSearch',
  CategoryList = 'CategoryList',
  CreditRequestScan = 'CatalogCreditRequestScan',
  ItemRecommendationsList = 'ItemRecommendationsList',
  Scan = 'CatalogScan',
  Search = 'CatalogSearch',
  TagPrintBatch = 'CatalogTagPrintBatch',
  VolumePromotionDetail = 'VolumePromotionDetail',
  VolumePromotionsList = 'VolumePromotionsList',
}

export enum CHAT_ROUTES {
  Base = 'ChatBase',
}

export enum ORDER_GUIDE_ROUTES {
  Base = 'OrderGuideBase',
  BrandPage = 'OrderGuideBrandPage',
  CatalogSearch = 'OrderGuideCatalogSearch',
  CreditRequestScan = 'OrderGuideCreditRequestScan',
  Edit = 'OrderGuideEdit',
  OrderGuideUnifiedSearch = 'OrderGuideUnifiedSearch',
  Scan = 'OrderGuideScan',
  TagPrintBatch = 'OrderGuideTagPrintBatch',
  VolumePromotionDetail = 'VolumePromotionDetail',
  VolumePromotionsList = 'VolumePromotionsList',
}

export enum EDIT_ORDER_GUIDE_ROUTES {
  AddPartitionItems = 'EditOrderGuideAddPartitionItems',
  Base = 'EditOrderGuideBase',
}

export enum MENU_INFO_ROUTES {
  Base = 'MenuInfoBase',
  ItemDetail = 'MenuInfoItemDetail',
  Search = 'MenuInfoSearch',
}

export enum PAYMENT_ROUTES {
  AutoPay = 'AutoPay',
  Base = 'PaymentBase',
  PaymentMethod = 'PaymentMethod',
}

export enum EMPLOYEE_MANAGEMENT_ROUTES {
  Employees = 'RestaurantEmployees',
}

export enum INSIGHTS_HUB_ROUTES {
  Base = 'InsightsHubBase',
  DraftDetails = 'DraftDetails',
  InvoiceDetails = 'InvoiceDetails',
  OrderDetails = 'OrderDetails',
  OrderManagement = 'OrderManagement',
}

export enum EMPLOYEE_ROUTES {
  Detail = 'EmployeeDetail',
  List = 'EmployeeList',
  NotificationSettings = 'EmployeeNotificationSettings',
}

export enum SUBSTITUTION_ROUTES {
  ChooseSubstitution = 'ChooseSubstitution',
  SearchCatalog = 'SearchCatalog',
  SelectSubstitutionQuantity = 'SelectSubstitutionQuantity',
}

export enum QUEUE_OFFLINE_ORDERS_ROUTES {
  Base = 'QueueOfflineOrdersBase',
}

export enum SMART_ORDER_CONTAINER_ROUTES {
  PlacedOrder = 'SmartOrderContainerPlacedOrder',
}

export enum ORDER_INBOUNDS_ROUTES {
  AddPAD = 'OrderInboundsAddPAD',
  AddPaymentMethod = 'OrderInboundsAddPaymentMethod',
  AddSearch = 'OrderInboundsAddSearch',
  CorrectionSearch = 'OrderInboundsCorrectionSearch',
  Detail = 'OrderInboundDetail',
  DSRTooling = 'OrderInboundsDSRTooling',
  EditOrderItemNote = 'OrderInboundsEditOrderItemNote',
  List = 'OrderInboundsList',
  Submit = 'OrderInboundsSubmit',
  SwapSearch = 'OrderInboundsSwapSearch',
  TabCardApplication = 'OrderInboundsTabCardApplication',
}

export enum DSR_TOOLING_ROUTES {
  Base = 'DSRToolingBase',
}

export enum HIDDEN_ALERTS_ROUTES {
  Base = 'HiddenAlertsBase',
}

export enum TAG_PRINT_BATCH_ROUTES {
  Base = 'TagPrintBatchBase',
  ImportTemplate = 'TagPrintBatchImportTemplate',
  Item = 'TagPrintBatchItem',
}

export enum SALES_PORTAL_ROUTES {
  AccountDetail = 'SalesPortalAccountDetail',
  AccountList = 'SalesPortalAccountList',
  Base = 'SalesPortalBase',
  Copilot = 'SalesPortalCopilot',
  EmployeeList = 'SalesPortalEmployeeList',
  Home = 'SalesPortalHome',
  Insights = 'SalesPortalInsights',
  NotFound = 'SalesPortalNotFound',
  OrderEntry = 'SalesPortalOrderEntry',
  OrderGuides = 'SalesPortalOrderGuides',
  PriceQuotesBuilder = 'SalesPortalPriceQuotesBuilder',
  PricingAgentReview = 'PricingAgentReview',
  PricingAgentTasks = 'PricingAgentTasks',
  PricingBookmarked = 'PricingBookmarked',
  PricingCustomerDetail = 'PricingCustomerDetail',
  PricingCustomers = 'PricingCustomers',
  PricingItemManagement = 'PricingItemManagement',
  PricingManagement = 'PricingManagement',
  PricingManagementReview = 'PricingManagementReview',
  PricingMicroProduct = 'PricingMicroProduct',
  PricingOverview = 'PricingOverview',
  ProspectDetail = 'SalesPortalProspectDetail',
  ProspectEmployeeList = 'SalesPortalProspectEmployeeList',
  ProspectFinder = 'SalesPortalProspectFinder',
  Prospects = 'SalesPortalProspects',
  Superintelligence = 'SalesPortalSuperintelligence',
}

export enum SALES_PORTAL_TAB_ROUTES {
  Accounts = 'SalesPortalAccountsTab',
  Insights = 'SalesPortalInsightsTab',
  OrderEntry = 'SalesPortalOrderEntryTab',
  OrderGuides = 'SalesPortalOrderGuidesTab',
  Pricing = 'SalesPortalPricingTab',
  Prospects = 'SalesPortalProspectsTab',
}

export enum FINANCE_HUB_ROUTES {
  Autopay = 'FinanceHubAutopay',
  AutopayRunPreview = 'FinanceHubAutopayRunPreview',
  Customers = 'FinanceHubCustomers',
  Home = 'FinanceHubHome',
  Invoices = 'FinanceHubInvoices',
  NotFound = 'FinanceHubNotFound',
}

export enum FINANCE_HUB_TAB_ROUTES {
  Autopay = 'FinanceHubAutopayTab',
  Customers = 'FinanceHubCustomersTab',
  Invoices = 'FinanceHubInvoicesTab',
}
